import { Component, OnInit, OnDestroy, inject, NgZone } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription, fromEvent } from 'rxjs';
import * as routerActions from 'src/app/STORE/actions/router.actions';
import { MessageService } from 'primeng/api';
import { AppGlobalService } from './services/app.global.service';
import { GlobalConstants } from './base/global.constants';
import { HttpClient } from '@angular/common/http';
import { HttpBaseService } from './base/http-base.service';
import { environment } from 'src/environments/environment';
import { AnnotationToolService } from './services/annotation-tool.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false //NOSONAR
})
export class AppComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private ngZone = inject(NgZone);
  messageService = inject(MessageService);
  appGlobalService = inject(AppGlobalService);
  http = inject(HttpClient);
  bs = inject(HttpBaseService);
  annotationToolService = inject(AnnotationToolService);

  title = 'eva-design-studio';
  isOuterRoute = false;
  isAppManagementRoute = false;
  queryParams: any;
  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  isOffLine = !navigator.onLine;
  subscriptions: Subscription[] = [];
  env = environment;
  constructor() {
    //this.handleCustomQueryParamsInUrl();
    this.listenRouterChange();
  }

  listenForQueryParams() {
    // console.log(this.route);
  }

  listenRouterChange() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.handleNavigationEnd(event);
      }
    });
  }

  handleNavigationEnd(event) {
    setTimeout(() => {
      document.querySelector('.activeParents')?.classList.remove('activeParents');
      document.querySelector('.mm-active')?.closest('.app-sidebar__heading')?.classList.add('activeParents');
    }, 10);

    let route = this.route.firstChild;
    let child = route;

    this.isOuterRoute = child?.routeConfig?.path === 'login';
    this.isAppManagementRoute = child?.routeConfig?.path === 'appmanagement';

    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
        route = child;
      } else {
        child = null;
      }
    }

    route?.data?.subscribe((data) => {
      this.store.dispatch(routerActions.setNavigationEnd({ routerEvent: data }));
    });
  }

  /* This queryparam is to handle the authentication request from prototype application   */
  handleCustomQueryParamsInUrl() {
    const url: string = window.location.href;
    const _params: any = url.split('?');
    if (_params?.[1]) {
      const params = new URLSearchParams(_params[1]);
      if (params.has(GlobalConstants.redirectUrlParam)) {
        const redirectUrl = params.get(GlobalConstants.redirectUrlParam);
        this.appGlobalService.write(GlobalConstants.redirectUrlParam, redirectUrl);
        localStorage.setItem(GlobalConstants.redirectUrlParam, redirectUrl ?? '');

        // Firebase passwordless email-link redirect
        if (redirectUrl === 'redirect-auth-page') {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.delete('redirectUrl');
          this.router.navigate(['/login', 'gcip-redirect'], {
            queryParams: Object.fromEntries(searchParams.entries())
          });
        }
      } else {
        this.appGlobalService.write(GlobalConstants.redirectUrlParam, null);
        localStorage.removeItem(GlobalConstants.redirectUrlParam);
      }
      if (params.has(GlobalConstants.appIdParam)) {
        this.appGlobalService.write(GlobalConstants.appIdParam, params.get(GlobalConstants.appIdParam));
        localStorage.setItem(GlobalConstants.appIdParam, params.get(GlobalConstants.appIdParam) ?? '');
      } else {
        this.appGlobalService.write(GlobalConstants.appIdParam, null);
        localStorage.setItem(GlobalConstants.appIdParam, '');
      }
      if (params.has(GlobalConstants.tokenParam)) {
        this.appGlobalService.write(GlobalConstants.tokenParam, params.get(GlobalConstants.tokenParam));
        localStorage.setItem(GlobalConstants.tokenParam, params.get(GlobalConstants.tokenParam) ?? '');
      } else {
        this.appGlobalService.write(GlobalConstants.tokenParam, null);
        localStorage.setItem(GlobalConstants.tokenParam, '');
      }

      if (params.has(GlobalConstants.tenantId)) {
        this.appGlobalService.write(GlobalConstants.tenantId, params.get(GlobalConstants.tenantId));
        localStorage.setItem(GlobalConstants.tenantId, params.get(GlobalConstants.tenantId) ?? '');
      } else {
        this.appGlobalService.write(GlobalConstants.tenantId, null);
      }
    }
  }

  handleAppConnectivityChanges() {
    this.subscriptions.push(
      this.appGlobalService.isOnline$.subscribe((isOnline) => {
        this.ngZone.run(() => {
          this.isOffLine = !isOnline;
        });
      })
    );
  }

  ngOnInit(): void {
    this.handleAppConnectivityChanges();
    this.handleCustomQueryParamsInUrl();
  }

  ngOnDestroy() {
    localStorage.removeItem('logout');
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    // this.store.dispatch(logoutUser());
    // alert("ngOndestroy")
    // console.log("ngOndestroy");
  }
}
